module.exports = __webpack_public_path__ + "img/sun2.e968dd53.svg";